import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import SettingHeader from 'components/Settings/Components/SettingHeader/settingHeader';
import { EditProfile } from 'components/Settings/Components/UserProfile/components/editProfile';
import { settingsConfig } from 'components/Settings/settingsConfig';

export const EditProfilePage = () => {
    useFullStoryPageView({ pageName: settingsConfig.userManagementEditUser.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={settingsConfig.userManagementEditUser.title} showBack={true} />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <EditProfile />
            </MainContent>
        </PageContainer>
    );
};
